//
import UserModel from "@/models/General/GUser"
import WarehouseModel from "@/models/Warehouse/WhWarehouse"
import TransferWarehouseStateModel from "@/models/Warehouse/WhTransferWarehouseState"

//
export default [
    {
      name: 'id',
      type: 'text-field',
      props: {
        label: 'Id',
      },
    },
    {
        name: "g_to_supervisor_id",
        props: {
            itemText: "full_name",
            itemValue: "id",
            label: "Solicitante",
            model: UserModel,
            noObject: true,
            paramSearch: "search",
        },
        type: "autocomplete-model",
        value: [],
    },
    {
        name: "wh_to_warehouse_id",
        props: {
            itemText: "name",
            itemValue: "id",
            label: "Destino",
            model: WarehouseModel,
            noObject: true,
            paramSearch: "search",
        },
        type: "autocomplete-model",
        value: [],
    },
    {
        name: "g_from_supervisor_id",
        props: {
            itemText: "full_name",
            itemValue: "id",
            label: "Responsable",
            model: UserModel,
            noObject: true,
            paramSearch: "search",
        },
        type: "autocomplete-model",
        value: [],
    },
    {
        name: "wh_from_warehouse_id",
        props: {
            itemText: "name",
            itemValue: "id",
            label: "Origen",
            model: WarehouseModel,
            noObject: true,
            paramSearch: "search",
        },
        type: "autocomplete-model",
        value: [],
    },
    {
        name: "wh_transfer_between_warehouse_state_id",
        props: {
            itemText: "state",
            itemValue: "id",
            label: "Estado",
            model: TransferWarehouseStateModel,
            noObject: true,
            paramSearch: "state",
        },
        type: "autocomplete-model",
        value: [],
    },
]